import moment from "moment";

export const completeDateFormat = (dateString) => {
  return moment.utc(dateString).format("MM/DD/yyyy");
};
export const completeTimeFormat = (dateString) => {
  return moment.utc(moment.utc(dateString).format("LTS"), "hh:mm A").format("HH:mm");
};
